import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "mt-3"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "mr-2"
};
const _hoisted_4 = {
  class: "grow"
};
const _hoisted_5 = {
  key: 0,
  class: "flex justify-end font-bold py-2"
};
import { BankCategory } from "../enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'Logs',
  props: {
    logs: null,
    balance: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_NCollapseItem = _resolveComponent("NCollapseItem");
      const _component_NCollapse = _resolveComponent("NCollapse");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NCollapse, {
        class: "mb-6"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BankCategory), category => {
          return _openBlock(), _createBlock(_component_NCollapseItem, {
            key: category,
            title: _ctx.$t(category),
            name: category
          }, {
            "header-extra": _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(_ctx.collect(__props.logs).filter(log => log.category === category).sum('amount'))), 1)]),
            default: _withCtx(() => [__props.logs.filter(log => log.category === category).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('no_entries')), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.logs.filter(log => log.category === category), log => {
              return _openBlock(), _createElementBlock("div", {
                key: log.id,
                class: "flex"
              }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$date(log.createdAt)), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(log.label), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$money(log.amount)), 1)]);
            }), 128))]),
            _: 2
          }, 1032, ["title", "name"]);
        }), 128))]),
        _: 1
      }), __props.balance ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$money(__props.balance)), 1)) : _createCommentVNode("", true)]);
    };
  }
});